var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-breadcrumbs"},[_c('v-breadcrumbs',{staticClass:"pa-0",attrs:{"items":_vm.items,"divider":_vm.divider},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return _c('v-breadcrumbs-item',{attrs:{"exact":"","to":item.to,"disabled":item.disabled}},[_vm._v(" "+_vm._s(item.text)+" ")])}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }